import gql from "graphql-tag";

const SHIPMENT_REQUESTS_QUERY = gql`
  query ShipmentRequestsQuery($limit: Int!, $offset: Int!, $orderBy: String!, $status: ShipmentRequestStatusEnum) {
    shipmentRequests(limit: $limit, offset: $offset, orderBy: $orderBy, status: $status) {
      id
      code
      status
      statusMessage
      insertedAt
      quantity
      constructionName
      operatorName
      equipmentCode
    }
  }
`;

export default SHIPMENT_REQUESTS_QUERY;
